import { connect } from 'react-redux';
import {
  fetchCustomerAuthorization,
  setActivationDialogOpen,
  setConfirmDialogOpen,
  setConfirmDialogType,
  setCustomerAuthorizationToActivate,
  setCustomerAuthorizationToDeactivate,
  setCustomerAuthorizationToDelete,
  setIsViewDrawerOpen,
  setSelectedAuthorizations,
} from '../store/customerAuthorizationSlice';
import CustomerAuthCard from './CustomerAuthCard';

const mapState = state => ({
  selectedAuthorizations: state.loadingManagement.customerAuthorizations.selectedAuthorizations,
});

const mapDispatchToProps = {
  fetchCustomerAuthorization,
  setActivationDialogOpen,
  setConfirmDialogOpen,
  setConfirmDialogType,
  setCustomerAuthorizationToActivate,
  setCustomerAuthorizationToDeactivate,
  setCustomerAuthorizationToDelete,
  setIsViewDrawerOpen,
  setSelectedAuthorizations,
};

export default connect(mapState, mapDispatchToProps)(CustomerAuthCard);
